import React from "react";
import { Card, Row, Col } from "antd";
import classes from "./IndustryDetailPage.module.scss";

const { Meta } = Card;

const NewsGrid = ({ IndustryDetails }) => {
  return (
    <div style={{ padding: "20px" }}>
      <Row gutter={[16, 16]} justify="start">
        {IndustryDetails?.nes.map((news) => (
          <Col xs={24} sm={12} md={8} key={news.uuid}>
            <a
              href={news.link}
              target="_blank"
              rel="noopener noreferrer"
              style={{ textDecoration: "none", color: "inherit" }}
            >
              <Card
                hoverable
                className={classes.newsCard}
                cover={
                  news.thumbnail?.resolutions?.[0]?.url ? (
                    <img
                      alt="news-thumbnail"
                      src={news.thumbnail.resolutions[0].url}
                      className={classes.cardImage}
                    />
                  ) : (
                    <div className={classes.placeholderImage}>
                      No Image Available
                    </div>
                  )
                }
              >
                <Meta
                  title={
                    <div className={classes.cardTitle}>
                      {news.title || "No Title Available"}
                    </div>
                  }
                  description={
                    <div className={classes.cardPublisher}>
                      {news.publisher || "Unknown Publisher"}
                    </div>
                  }
                />
              </Card>
            </a>
          </Col>
        ))}
      </Row>
    </div>
  );
};

export default NewsGrid;
